import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import SvgIcon from 'components/Icon/SvgIcon'
import { formatNumber } from 'helpers'
import { useEffect, useState } from 'react'
import { Box, MapPin } from 'react-feather'
import { Card, CardText, Input } from 'reactstrap'
import SplitStockCard from '../Card/SplitStockCard'
import './modal.css'

const SplitStockModal = ({
  isOpen,
  onClose,
  selectedStock,
  splitItems,
  enableSplit,
  addSplitItem,
  onShowItem,
  setIndexSelectedSplitStock,
  onChangeValue,
  onSplitStock,
  loading,
  onLockValue,
  bulkSplitCount,
  setBulkSplitCount,
}) => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false)

  useEffect(() => {
    const checkAmounts = splitItems.every((item) => item.amount)
    setIsButtonEnabled(checkAmounts)
  }, [splitItems])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <CardText className="mt-2" style={{ fontSize: 14 }}>
          Stok berikut akan dipisah menjadi beberapa bagian
        </CardText>
        <Card className="border-0 shadow-sm">
          <div className="d-flex align-items-center regular-padding-horizontal mt-2 small-padding-bottom">
            <img
              src={selectedStock?.item?.linkFoto}
              style={{ width: 80, height: 80, borderRadius: 99 }}
            />
            <div className="pl-4">
              <CardText className="no-padding fw-semibold">
                {selectedStock?.item?.nameItem}
              </CardText>
              <div className="d-flex align-items-center mt-2">
                <Box size={15} />
                {selectedStock?.amount ? (
                  <CardText
                    className="no-padding"
                    style={{ fontSize: 13, marginLeft: 10 }}
                  >
                    {formatNumber(selectedStock?.amount)} {selectedStock?.unit}
                    {selectedStock?.bundle
                      ? ` • ${selectedStock.bundle} Bundle`
                      : ''}
                  </CardText>
                ) : null}
              </div>
              {(selectedStock?.city ||
                selectedStock?.district ||
                selectedStock?.province) && (
                <div className="d-flex align-items-center mt-2">
                  <MapPin size={15} />
                  <CardText className="pl-2" style={{ fontSize: 13 }}>
                    {selectedStock?.city ||
                      selectedStock?.district ||
                      selectedStock?.province}
                  </CardText>
                </div>
              )}
            </div>
          </div>
        </Card>
      </div>
      <div>
        <div className="regular-padding-horizontal regular-border-bottom mt-3" />
        {splitItems?.map((el, i) => (
          <div className="mt-3" key={i}>
            <SplitStockCard
              index={i}
              item={el}
              onShowItem={onShowItem}
              setIndexSelectedSplitStock={setIndexSelectedSplitStock}
              onChangeValue={onChangeValue}
              selectedStock={selectedStock}
              onLockValue={() => onLockValue(el)}
            />
          </div>
        ))}
      </div>

      <div className="bottom-bar">
        <div className="regular-border-bottom pb-2">
          <P className="fw-semibold" style={{ fontSize: 14 }}>
            {`Total bagian saat ini: ${splitItems.length}`}
          </P>
        </div>
        <div>
          <P color={'grey'} style={{ fontSize: 14 }}>
            Jumlah bagian yang ingin ditambahkan
          </P>
        </div>
        <div className="top-row">
          <div className="stepper">
            <div
              className={`stepper-btn ${bulkSplitCount > 1 && splitItems?.length < 500 ? 'active' : 'disabled'}`}
              onClick={() => {
                if (bulkSplitCount > 1 && splitItems?.length < 500) {
                  setBulkSplitCount((prev) => prev - 1)
                }
              }}
            >
              <SvgIcon
                name="minus"
                color="black"
                style={{ cursor: 'pointer' }}
              />
            </div>
            <Input
              disabled={splitItems?.length === 500}
              type="number"
              min={0}
              max={500}
              value={bulkSplitCount}
              style={{ flex: 0.5, marginLeft: 5, textAlign: 'center' }}
              onChange={(e) => {
                let rawVal = e.target.value
                let val = Number(rawVal)

                if (rawVal === '') {
                  setBulkSplitCount('')
                  return
                }
                if (!isNaN(val)) {
                  if (val > 500 - splitItems?.length)
                    val = 500 - splitItems?.length
                  if (val < 1) val = 1
                  setBulkSplitCount(val)
                }
              }}
            />

            <div
              className={`stepper-btn ${bulkSplitCount + splitItems?.length < 500 ? 'active' : 'disabled'}`}
              onClick={() => {
                if (bulkSplitCount + splitItems?.length < 500) {
                  setBulkSplitCount((prev) => prev + 1)
                }
              }}
            >
              <SvgIcon
                name="plus"
                color="black"
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>
          <CustomButton
            disabled={bulkSplitCount < 1 || splitItems?.length === 500}
            onClick={addSplitItem}
            outline
            className="fw-semibold"
            color="primary"
          >
            {`Tambah ${bulkSplitCount} Bagian`}
          </CustomButton>
        </div>
        {bulkSplitCount + splitItems?.length === 500 ? (
          <small style={{ color: 'red', marginTop: 2 }}>
            Anda sudah mencapai batas jumlah yang bisa ditambahkan.
          </small>
        ) : splitItems?.length === 500 ? (
          <small style={{ color: 'red', marginTop: 2 }}>
            Anda sudah mencapai jumlah maksimal 500 bagian.
          </small>
        ) : null}

        <div
          className="bottom-row pt-3"
          style={{ borderTop: '1px solid lightGrey' }}
        >
          <CustomButton
            color="primary"
            disabled={loading || !isButtonEnabled}
            onClick={onSplitStock}
            className="fw-semibold btn-pindah"
          >
            Pisah
          </CustomButton>
        </div>
      </div>
    </div>
  )
}

export default SplitStockModal
